import { render, staticRenderFns } from "./PolygonLabel.vue?vue&type=template&id=14131564"
import script from "./PolygonLabel.vue?vue&type=script&lang=js"
export * from "./PolygonLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports